import { render, staticRenderFns } from "./WageReview.vue?vue&type=template&id=70f96415&scoped=true&"
import script from "./WageReview.vue?vue&type=script&lang=js&"
export * from "./WageReview.vue?vue&type=script&lang=js&"
import style0 from "./WageReview.vue?vue&type=style&index=0&id=70f96415&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f96415",
  null
  
)

export default component.exports